import { render } from "./UserConfigHomeView.vue?vue&type=template&id=77f21d1a&scoped=true"
import script from "./UserConfigHomeView.vue?vue&type=script&lang=js"
export * from "./UserConfigHomeView.vue?vue&type=script&lang=js"

import "./UserConfigHomeView.vue?vue&type=style&index=0&id=77f21d1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f21d1a"]])

export default __exports__